import { useQueryClient } from "@tanstack/react-query";
import { usePrefectMyEventsQuery } from "queries/useGetMyEventsQuery";
import { slotsQueryKey } from "./useGetEventDetailQuery";
import { invitationQueryKey } from "./useGetMyInvitationsQuery";

export const useInvitQueriesInvalidation = (eventId: string) => {
  const client = useQueryClient();
  const prefetchMyEvents = usePrefectMyEventsQuery();

  return () => {
    client.invalidateQueries({ queryKey: slotsQueryKey(eventId) }).then();
    client.invalidateQueries({ queryKey: invitationQueryKey(eventId) }).then();
    client
      .invalidateQueries({
        queryKey: ["getMyEvents"],
      })
      .then();
    prefetchMyEvents();
  };
};

export const useSlotsQueriesInvalidation = (eventId: string) => {
  const client = useQueryClient();

  return () => {
    client
      .invalidateQueries({
        queryKey: [eventId],
      })
      .then();
  };
};
